/* eslint-disable */
/**
 * Available rules options:
 *
 * Bool     required
 * Bool     numbers_only
 * Number   min_text_length
 * Number   max_text_length
 * Bool     email
 */
import EventBus from '@/eventBus.js';
export default {
  data() {
    return {
      checkForError: false,
      errorMsg: '',
      errorMsgAdditional: ''
    };
  },
  props: {
    rules: {
      type: Object,
      default: () => {
        return {
          required: false
        }
      }
    }
  },
  mounted() {
    // console.log(this.$props)
    if(this.$props.hasOwnProperty('multiSelect') && this.multiSelect){
      EventBus.$on('checkSubmitErrors',() => {
        this.checkForError = true;
        this.validateInput(this.preselected);
      });
    } else {
      EventBus.$on('checkSubmitErrors',() => {
        this.checkForError = true;
        this.validateInput(this.value);
      });
    }

  },
  computed: {
    shouldShowError() {
      let error;
      if(this.$props.hasOwnProperty('multiSelect') && this.multiSelect){
        error = this.validateInput(this.preselected)
      } else {
        error = this.validateInput(this.value)
      }

      this.checkForError = error.errCheck
      this.errorMsg = error.errorMsg
      this.errorMsgAdditional = error.errorMsgAdditional

      return error.showError
    },
  },
  methods: {
    externValidate(value) {
      const error = this.validateInput(value)

      this.checkForError = error.errCheck
      this.errorMsg = error.errorMsg
      this.errorMsgAdditional = error.errorMsgAdditional

      return error.showError
    },
    validateInput(value) {
      let errCheck = this.checkForError
      const errorMsg = '';
      const errorMsgAdditional = '';
      const showError = false;

      // prioritize if conditions by importance
      if(Array.isArray(value)) {
        // by default dont show any error before start typing in field
        if (!errCheck && value.length > 0) {
          errCheck = true;
        }
        if (errCheck && this.rules.required && value.length == 0) {
          return {
            errCheck,
            showError: true,
            errorMsg: 'error_required_field',
            errorMsgAdditional
          };
        }
      } else {
        // by default dont show any error before start typing in field
        if (!errCheck && value) {
          errCheck = true;
        }

        if (errCheck && this.rules.required && !value) {
          return {
            errCheck,
            showError: true,
            errorMsg: 'error_required_field',
            errorMsgAdditional
          };
        }
      }

      if (errCheck && typeof this.rules.numbers_only !== 'undefined' && this.rules.numbers_only) {
        const pattern = /^\d+$/;
        const number = pattern.test(value);
        if (!number) {
          return {
            errCheck,
            showError: true,
            errorMsg: 'error_not_a_number',
            errorMsgAdditional
          };
        }
      }

      if (errCheck && typeof this.rules.min_text_length !== 'undefined' && value.length < this.rules.min_text_length) {
        return {
          errCheck,
          showError: true,
          errorMsg: 'error_min_field_length',
          errorMsgAdditional: this.rules.min_text_length
        };
      }

      if (errCheck && typeof this.rules.max_text_length !== 'undefined' && value.length > this.rules.max_text_length) {
        return {
          errCheck,
          showError: true,
          errorMsg: 'error_max_field_length',
          errorMsgAdditional: this.rules.max_text_length
        };
      }

      if (errCheck && typeof this.rules.email !== 'undefined' && this.rules.email) {
        if(value.indexOf('ø') > -1 || value.indexOf('æ') > -1 || value.indexOf('å') > -1){
          return {
            errCheck,
            showError: true,
            errorMsg: 'unable_char',
            errorMsgAdditional
          };
        }

        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const valid = pattern.test(value)
        if (!valid) {
          return {
            errCheck,
            showError: true,
            errorMsg: 'error_invalid_email',
            errorMsgAdditional
          };
        }
      }

      if (errCheck && typeof this.rules.password !== 'undefined' && this.rules.password) {

        const pattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/
        const valid = pattern.test(value)
        if (!valid) {
          return {
            errCheck,
            showError: true,
            errorMsg: 'password_error',
            errorMsgAdditional
          };
        }
      }

      return {
        errCheck,
        showError,
        errorMsg,
        errorMsgAdditional
      };
    }
  },
  beforeDestroy(){
    EventBus.$off('checkSubmitErrors');
  },
}
